export const LOADED_ADDRESSTYPES = 'LOADED_ADDRESSTYPES';
export const LOADING_ADDRESSTYPES = 'LOADING_ADDRESSTYPES';

export interface LoadingAddressTypes {
  type: typeof LOADING_ADDRESSTYPES;
}
export interface LoadedAddressTypes {
  type: typeof LOADED_ADDRESSTYPES;
  payload: AddressTypesViewModel[];
}
export type AddressTypesActionTypes =
  | LoadedAddressTypes
  | LoadingAddressTypes;

export interface AddressTypesViewModel {
  id: number;
  addressType: string;
}
  
export interface AddressTypesState {
  globalAddressTypes: AddressTypesViewModel[];
  loading: boolean;
  loaded: boolean;
}
